// @ts-nocheck
import { httpClient } from '../../../core/network';

class CorrespondenceService {
  static fetchCorrespondence(userId) {
    const apiUrl = `/customers/${userId}/correspondence`;
    return httpClient.get(apiUrl);
  }
}

export default CorrespondenceService;
